<template>
  <div>
    <PageHeader :schema="$schemas.billetControl" />
    <PageContent>
      <DynamicFormPage
        :schema="$schemas.billetControl"
        :service="$api.billetControls"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateBilletControl',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
